/* País pelo nome, gravando o código ISO2 que vai na DPS. A lista vem do Anexo A, sem o
   Brasil: a Sefin não aceita BR em local ou endereço no exterior (E0246, E0304). */
import React from 'react';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { Select } from 'chakra-react-select';
import _ from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';
import { useNfseEmissao } from '../../../../../hooks/useNfseEmissao';
import { INfsePais } from '../../../../../types/nfseEmissao';
import { extractErrorMessage } from '../../../../../utils/ErrorUtils';
import { propsMenuSelect } from '../../../../../utils/selectMenu';

interface Opcao {
  value: string;
  label: string;
}

const opcao = (p: INfsePais): Opcao => ({ value: p.codigo, label: `${p.nome} · ${p.codigo}` });

export function PaisBusca({
  name,
  label,
  isRequired,
  isDisabled,
  controlMb,
}: {
  name: string;
  label: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  controlMb?: number;
}) {
  const { getPaises } = useNfseEmissao();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = _.get(errors, name);
  const paises = useQuery({
    queryKey: ['nfse-paises'],
    queryFn: getPaises,
    staleTime: Infinity,
  });
  const opcoes = (paises.data ?? []).map(opcao);

  return (
    <FormControl isRequired={isRequired} isInvalid={!!error} mb={controlMb ?? 5}>
      <FormLabel fontWeight="bold" mb={1} htmlFor={`${name}-busca`}>
        {label}
      </FormLabel>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange, onBlur } }) => (
          <Select<Opcao>
            inputId={`${name}-busca`}
            placeholder="Digite o nome do país"
            options={opcoes}
            value={opcoes.find(o => o.value === value) ?? null}
            onChange={item => onChange((item as Opcao | null)?.value ?? '')}
            onBlur={onBlur}
            isLoading={paises.isLoading}
            noOptionsMessage={() => 'Nenhum país'}
            isClearable
            isDisabled={isDisabled}
            isInvalid={!!error}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
            styles={{ menuPortal: base => ({ ...base, zIndex: 2000 }) }}
            {...propsMenuSelect}
          />
        )}
      />
      <FormErrorMessage>{extractErrorMessage(error?.message)}</FormErrorMessage>
    </FormControl>
  );
}
